import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between mb-2" }
const _hoisted_2 = { class: "flex items-center text-gray-700 text-sm" }
const _hoisted_3 = {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  class: "w-4 h-4 mr-1"
}
const _hoisted_4 = { class: "text-gray-400" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = /*#__PURE__*/_createVNode("svg", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  class: "w-4 h-4 mr-2"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M5 13l4 4L19 7" })
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "既読", -1)
const _hoisted_8 = { class: "flex justify-between" }
const _hoisted_9 = { class: "font-medium text-sm mb-2" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 提出物を確認する")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 提出物を確認する")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 今回の成果を確認する")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 画像を確認する")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_icon = _resolveComponent("m-icon")

  return (_openBlock(), _createBlock("section", {
    class: ["px-8 py-3 cursor-pointer transition-all duration-300", _ctx.dynamicSectionCss],
    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.select && _ctx.select(...args)))
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        (_openBlock(), _createBlock("svg", _hoisted_3, [
          _createVNode("path", { d: _ctx.categoryPath }, null, 8, ["d"])
        ])),
        _createVNode("span", null, _toDisplayString(_ctx.categoryName), 1),
        _createVNode("span", _hoisted_4, "・" + _toDisplayString(_ctx.timeText), 1)
      ]),
      _createVNode("div", _hoisted_5, [
        (_ctx.isSubmission)
          ? (_openBlock(), _createBlock("button", {
              key: 0,
              class: "flex items-center px-2 py-1 rounded text-sm text-white bg-primary-500 hover:bg-primary-600 transition-all duration-300 cursor-pointer mr-2",
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)), ["stop"]))
            }, " 確認済にする "))
          : _createCommentVNode("", true),
        _createVNode("div", {
          class: "flex items-center px-2 py-1 rounded text-sm text-gray-500 transition-all duration-300 cursor-pointer hover:bg-gray-100",
          onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.check && _ctx.check(...args)), ["stop"]))
        }, [
          _hoisted_6,
          _hoisted_7
        ])
      ])
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode("h3", _hoisted_9, _toDisplayString(_ctx.item.data.title), 1),
      (_ctx.isSubmission)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: "flex items-center text-sm text-gray-500 px-2 py-1 mb-1 transition-all duration-300 whitespace-nowrap cursor-pointer hover:bg-gray-100",
            onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openSubmission && _ctx.openSubmission(...args)), ["stop"]))
          }, [
            _hoisted_10,
            _createVNode(_component_m_icon, { type: "popup" })
          ]))
        : _createCommentVNode("", true),
      (_ctx.isThread)
        ? (_openBlock(), _createBlock("div", {
            key: 1,
            class: "flex items-center text-sm text-gray-500 px-2 py-1 mb-1 transition-all duration-300 whitespace-nowrap cursor-pointer hover:bg-gray-100",
            onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openThread && _ctx.openThread(...args)), ["stop"]))
          }, [
            _hoisted_11,
            _createVNode(_component_m_icon, { type: "popup" })
          ]))
        : _createCommentVNode("", true),
      (_ctx.hasReflectionImages)
        ? (_openBlock(), _createBlock("div", {
            key: 2,
            class: "flex items-center text-sm text-gray-500 px-2 py-1 mb-1 transition-all duration-300 whitespace-nowrap cursor-pointer hover:bg-gray-100",
            onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openHistory && _ctx.openHistory(...args)), ["stop"]))
          }, [
            _hoisted_12,
            _createVNode(_component_m_icon, { type: "popup" })
          ]))
        : _createCommentVNode("", true),
      (_ctx.isImageMessage)
        ? (_openBlock(), _createBlock("div", {
            key: 3,
            class: "flex items-center text-sm text-gray-500 px-2 py-1 mb-1 transition-all duration-300 whitespace-nowrap cursor-pointer hover:bg-gray-100",
            onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openImage && _ctx.openImage(...args)), ["stop"]))
          }, [
            _hoisted_13,
            _createVNode(_component_m_icon, { type: "popup" })
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.item.data.content && !_ctx.isImageMessage)
      ? (_openBlock(), _createBlock("p", {
          key: 0,
          class: ["p-3 rounded-md text-sm text-gray-800 whitespace-pre-wrap break-words", _ctx.dynamicContentCss]
        }, _toDisplayString(_ctx.item.data.content), 3))
      : _createCommentVNode("", true)
  ], 2))
}